<script>
import { mapActions, mapGetters } from 'vuex'
import SessionTimeoutModal from '@/components/common/SessionTimeoutModal'

import Fullscreen from '@/layouts/Fullscreen.vue'
import NavbarWithSidebar from '@/layouts/NavbarWithSidebar.vue'
import NavbarWithFooter from '@/layouts/NavbarWithFooter.vue'
import FullscreenWithFooter from "@/layouts/FullscreenWithFooter.vue";
import {getLogoURLs} from "@/helpers/logo";
import SmartLayout from "@/layouts/SmartLayout.vue";
import Notifications from "@/components/common/Notifications.vue";
import Modals from "@/components/common/Modals.vue";
import {applyCustomCSS} from "@/helpers/cssLoader";

export default {
  name: 'App',
  components: {
    Notifications,
    Modals,
    SessionTimeoutModal,
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'css']),
    layout() {
      const layout = this.$route.meta.layout;
      if(layout){
        switch(layout) {
          case 'navbar-with-sidebar':
            return NavbarWithSidebar;
          case 'fullscreen-with-footer':
            return FullscreenWithFooter;
          case 'navbar-with-footer' || 'navbar' || 'navbar-only':
            return NavbarWithFooter;
          case 'fullscreen' || 'full' || 'full-screen':
            return Fullscreen;
          default:
            return SmartLayout;
        }
      }
      return SmartLayout
    },
    requiresAuth: function () {
      return this.$route.meta.requiresAuth
    },
    coloredCursor: function () {
      switch (window.config.VUE_APP_STAGE) {
        case 'DEVELOP':
          return (
            'url("' +
            window.config.VUE_APP_BASE_URL +
            '/cursor/development.cur"), pointer'
          )
        case 'TEST':
          return (
            'url("' +
            window.config.VUE_APP_BASE_URL +
            '/cursor/testStage.cur"), pointer'
          )
        case 'QA':
          return (
            'url("' +
            window.config.VUE_APP_BASE_URL +
            '/cursor/preLiveStage.cur"), pointer'
          )
        default:
          return 'default'
      }
    }
  },
  watch: {
    css: {
      immediate: true,
      deep: true,
      handler(newCss) {
        applyCustomCSS(newCss.custom);
      }
    }
  },
  created() {
    this.loadErrors()
    this.createScripts()
    this.setFavicon()
    this.getWhiteLabelAssets()
    this.$store.dispatch('truncateNotifications')
    this.$store.dispatch('closeModal')
  },
  methods: {
    ...mapActions(['loadErrors', 'getWhiteLabelAssets']),
    setFavicon() {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = getLogoURLs()?.favicon;
      document.head.appendChild(link);
    },
    createScripts() {
      for (let scripts in window.config.scripts) {
        let tag = document.createElement('script')
        let position = window.config.scripts[scripts]
        for (let pos in position) {
          let script = position[pos]
          for (let scriptAttrKey in script) {
            let scriptAttrValue = script[scriptAttrKey]

            if (scriptAttrKey !== 'code') {
              // set attributes
              tag.setAttribute(scriptAttrKey, scriptAttrValue)
            } else {
              // append code directly into script-tag
              tag.appendChild(document.createTextNode(scriptAttrValue))
            }
          }
          // append script into document
          document.getElementsByTagName(pos)[0].appendChild(tag)
        }
      }
    }
  }
}
</script>
<template>
  <v-app :style="{ cursor: coloredCursor}">
    <SessionTimeoutModal v-if="requiresAuth" />
    <Notifications />
    <Modals />
    <component :is="layout"></component>
  </v-app>
</template>

<style lang="scss">
@import './styles/variables.scss';
@import './styles/fonts.scss';
@import './styles/main.scss';
@import './styles/scrollbar.scss';
@import './styles/inputs.scss';
// overlapped error-text fix
.v-input--checkbox {
  .v-label {
    height: auto;
  }
}
.wordBreak {
  word-break: break-word;
}

.wordBreak-all {
  word-break: break-all;
}
.row {
  margin-top: 0;
  margin-bottom: 0;
}

.row + .row {
  margin-top: 0;
}
</style>
